import React, { createContext, useContext, useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';
import Toast from '../components/core/Util/Toast/Toast'; // <- seu Toast aqui
import { getUserSession } from '../util/core/Session';
import config from '../../application/config/config';

const SocketContext = createContext(null);

export const SocketProvider = ({ children }) => {
  const socketRef = useRef(null);
  const listenerRef = useRef(null);
  const storage = getUserSession();

  const setMessageListener = useCallback((callback) => {
    listenerRef.current = callback;
  }, []);

  const clearMessageListener = useCallback(() => {
    listenerRef.current = null;
  }, []);

  useEffect(() => {
    const socket = io(config.endpoints.backend, {
      auth:{
        token: !!storage ? storage.token : ''
      }
    });
    socketRef.current = socket;

    const handleMessage = (data) => {
      if (!data.byUser || (data.byUser && data.core_user_id === storage.user.id)) {
        Toast[data.status === 1 ? 'success' : 'error'](data.message);
        if (listenerRef.current) {
          listenerRef.current(data); 
        }
      }
    };

    socket.on('message', handleMessage);

    return () => {
      socket.off('message', handleMessage);
      socket.disconnect();
    };
  }, []);

  return (
    <SocketContext.Provider
      value={{
        socket: socketRef.current,
        setMessageListener,
        clearMessageListener
      }}
    >
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
